import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  default: {
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(2),
    },
  },
  compact: {
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  fullwidth: {
    width: '100%',
  },
}))
